<template>
  <layout title="Sign In">
    <div class="flex flex-col justify-center 2xl:pt-20 pt-0 pb-10">
      <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <h2
          class="mt-3 2xl:mt-6 text-3xl font-extrabold leading-9 text-center text-gray-900 lg:text-5xl"
        >
          Sign in
        </h2>
        <p class="mt-4 text-sm leading-5 text-center text-gray-600 max-w">
          or, you can
          <inertia-link :href="$route('register')" class="link">
            sign up here
          </inertia-link>
        </p>
      </div>

      <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div
          class="px-4 py-8 bg-white border shadow border-gray-50 sm:rounded-lg sm:px-10"
        >
          <form role="form" @submit.prevent="login" method="POST">
            <div>
              <label
                for="email"
                class="block text-sm font-medium leading-5 text-gray-700"
                >Email address</label
              >
              <div class="mt-1 rounded-md shadow-sm">
                <input
                  id="email"
                  type="email"
                  name="email"
                  v-model="form.email"
                  required
                  class="w-full"
                  autofocus
                  placeholder="Email address"
                  maxlength="190"
                />
              </div>

              <div class="error" v-if="errors.email">{{ errors.email }}</div>
              <div class="error" v-if="errors.g_recaptcha_token">
                {{ errors.g_recaptcha_token }}
              </div>
            </div>

            <div class="mt-6">
              <label
                for="password"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Password
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <InputIcon :iconRight="false">
                  <input
                    id="password"
                    :type="form.inputType"
                    name="password"
                    v-model="form.password"
                    required
                    class="w-full"
                    placeholder="Password"
                    slot="input"
                    maxlength="190"
                  />

                  <EyeIcon
                    class="absolute mx-2 text-gray-500 cursor-pointer"
                    slot="icon"
                    @click="toggleSeePassword"
                    v-if="form.inputType === 'password'"
                  />
                  <EyeOffIcon
                    class="absolute mx-2 text-gray-500 cursor-pointer"
                    slot="icon"
                    @click="toggleSeePassword"
                    v-else
                  />
                </InputIcon>
              </div>
              <div class="error" v-if="errors.password">
                {{ errors.password }}
              </div>
            </div>

            <div class="flex items-center justify-between mt-6">
              <div class="flex items-center">
                <input
                  id="remember"
                  name="remember"
                  type="checkbox"
                  v-model="form.remember"
                />
                <label
                  for="remember"
                  class="block ml-2 text-sm leading-5 text-gray-900"
                >
                  Remember me
                </label>
              </div>

              <div class="text-sm leading-5">
                <inertia-link :href="$route('password.sendemail')" class="link">
                  Forgot your password?
                </inertia-link>
              </div>
            </div>

            <div class="mt-6">
              <span class="block w-full rounded-md shadow-sm">
                <button type="submit" class="btn-primary w-full">
                  Sign in
                </button>
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>

    <modal :show="showCaptchaModal" @closeModal="closeCaptchaModal">
      <div class="text-center mb-5">
        <h3 class="text-xl font-extrabold text-primary-color">Security Verification</h3>
        <p class="mt-1 text text-gray-500">Please complete the challenge to continue.</p>
      </div>
      <div ref="wafCaptcha" class="flex justify-center"></div>
    </modal>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");
import InputIcon from "./../Components/Layout/Resources/inputIcon.vue";
import { EyeIcon, EyeOffIcon } from "@vue-hero-icons/outline";
import { wafInertiaPost } from "../utils/waf";
import Modal from "../Components/modal.vue";
export default {
  components: { layout, InputIcon, EyeIcon, EyeOffIcon, Modal },
  props: {
    errors: Object,
  },
  data() {
    return {
      form: {
        email: null,
        password: null,
        remember: false,
        inputType: "password",
        inputValue: "",
        g_recaptcha_token: null,
      },
      showCaptchaModal: false,
      siteKey: process.env.MIX_RECAPTCHA_SITE_KEY,
    };
  },
  methods: {
    login() {
      this.getRecaptchaToken();
    },
    async submit() {
      this.showCaptchaModal = false;
      await wafInertiaPost(this.$inertia, "/login", this.form, {
        onSuccess: (e) => {
          this.showCaptchaModal = false;
          if (e.props.flash.message != null) {
            this.$store.commit("showFlashMessage", {
              message: e.props.flash.message,
              type: e.props.flash.message_type,
            });
          }
        },
        onError: () => {
          this.showCaptchaModal = false;
        },
      }, this.$refs.wafCaptcha, () => {
        this.showCaptchaModal = true;
      }, () => {
        this.showCaptchaModal = false;
      });
    },
    getRecaptchaToken() {
      let _this = this;
      if (typeof grecaptcha === 'undefined' || !this.siteKey) {
        this.submit();
        return;
      }
      grecaptcha
        .execute(this.siteKey, {
          action: "login",
        })
        .then(function (token) {
          _this.form.g_recaptcha_token = token;
          _this.submit();
        })
        .catch(function () {
          _this.submit();
        });
    },
    closeCaptchaModal() {
      this.showCaptchaModal = false;
      if (this.$refs.wafCaptcha) this.$refs.wafCaptcha.innerHTML = '';
    },
    toggleSeePassword() {
      this.form.inputType =
        this.form.inputType == "password" ? "text" : "password";
    },
  },
};
</script>